import * as React from "react";
import { AppStore } from "../stores/app.store";
import { useAppStore } from "./app.store.consumer";
import { ModalRenderer } from "./modal";

const ErrorModal: React.FC<{ errorMessage: string; reloadCallback: () => void; logoutAndRestartCallback: () => void }> = ({ errorMessage, reloadCallback, logoutAndRestartCallback }) => {
    return <ModalRenderer content={getErrorModalLayout(errorMessage, reloadCallback, logoutAndRestartCallback)} isShow={true} />;
};

const getErrorModalLayout = (errorMessage: string, reloadCallback: () => void, logoutAndRestartCallback: () => void) => (
    <div className="info-modal-content">
        <div className="info-modal-header paint-lgrey">
            <h5 className="info-modal-title ink-dgrey">System notification</h5>
        </div>
        <div className="info-modal-border"></div>
        <div className="info-modal-body">
            <div>There was a network communication error or another issue on this screen. The support team has been notified and the issue will be reviewed shortly.</div>
            <div className="vspace20"></div>

            {errorMessage && (
                <>
                    <textarea className="form-fit paint-lgrey" defaultValue={errorMessage} rows={4} disabled />
                    <div className="vspace10"></div>
                </>
            )}
            <div className="info-modal-buttons">
                <button onClick={logoutAndRestartCallback} className="btn-base btn-primary  btn-fit-mobile  anim-btn-hover">
                    Restart app
                </button>
                <div className="hspace15"></div>
                <button onClick={reloadCallback} className="btn-base btn-secondary  btn-fit-mobile  anim-btn-hover">
                    Reload page
                </button>
            </div>
        </div>
    </div>
);

@useAppStore()
export class Error extends React.Component<{ appStore?: AppStore }> {

    render() {
        return this.props.appStore.errorVisible &&
            <ErrorModal errorMessage={this.props.appStore.errorMessage} reloadCallback={() => window.location.reload(true)} logoutAndRestartCallback={() => this.props.appStore.userStore.logout()} />
    }
}